import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMehFace = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M24 48C37.2546 48 48 37.2546 48 24C48 10.7454 37.2546 0 24 0C10.7454 0 0 10.7454 0 24C0 37.2546 10.7454 48 24 48Z",
			fill: "#FF5C00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7144 31.2076C12.7144 32.5513 11.251 33.6403 9.44416 33.6403C7.63727 33.6403 6.1709 32.5513 6.1709 31.2076C6.1709 29.8639 7.63727 28.7749 9.44416 28.7749C11.251 28.7749 12.7144 29.8639 12.7144 31.2076Z",
			fill: "#FFD525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.416 31.2076C41.416 32.5513 39.9527 33.6403 38.1458 33.6403C36.3389 33.6403 34.8726 32.5513 34.8726 31.2076C34.8726 29.8639 36.3389 28.7749 38.1458 28.7749C39.9527 28.7749 41.416 29.8639 41.416 31.2076Z",
			fill: "#FFD525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5039 21.3052C16.9916 20.7837 16.4793 20.2652 15.967 19.7437C15.5559 19.3265 14.8933 19.5504 14.7215 20.072C14.1632 21.7592 12.5956 22.9157 10.8255 22.9771C9.04008 23.0384 7.36203 21.8942 6.74542 20.2192C6.54909 19.6823 5.93861 19.4952 5.49992 19.891C5.17475 20.1824 4.93853 20.5597 4.68391 20.9125C4.42315 21.2714 4.1624 21.6273 3.89857 21.9862C3.65929 22.3145 3.84335 22.8176 4.16546 23.0078C4.54279 23.2286 4.94773 23.066 5.18395 22.7409C5.42937 22.4034 5.67478 22.066 5.92327 21.7285L6.35582 21.1364C6.39263 21.0843 6.43251 21.0321 6.46933 20.98C6.28833 21.2285 6.46319 21.0291 6.55215 20.9463C6.13801 20.8358 5.7208 20.7254 5.30666 20.618C6.15948 22.9433 8.32837 24.4987 10.8224 24.4711C13.2705 24.4435 15.3964 22.7623 16.1572 20.4708C15.7431 20.5812 15.3258 20.6916 14.9117 20.799C15.424 21.3205 15.9363 21.842 16.4486 22.3605C17.1235 23.0476 18.1788 21.9923 17.5039 21.3052Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.27332 23.2654C7.98802 23.8513 7.70272 24.4372 7.41742 25.0263C7.23949 25.3913 7.31619 25.83 7.68431 26.0447C8.01563 26.238 8.52794 26.1429 8.70587 25.7778C8.99116 25.1919 9.27646 24.606 9.56176 24.017C9.73969 23.6519 9.663 23.2132 9.29487 22.9985C8.96355 22.8052 8.45124 22.9003 8.27638 23.2654",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1534 23.8021C12.3805 24.4126 12.6075 25.0261 12.8345 25.6366C12.9756 26.017 13.3345 26.2716 13.7517 26.1581C14.1168 26.0569 14.4144 25.6213 14.2732 25.2409C14.0462 24.6304 13.8192 24.0169 13.5922 23.4064C13.4511 23.026 13.0922 22.7714 12.675 22.8849C12.3099 22.9861 12.0123 23.4217 12.1534 23.8021Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.5327 21.3052C31.045 20.7837 31.5573 20.2652 32.0696 19.7437C32.4807 19.3265 33.1433 19.5504 33.3151 20.072C33.8734 21.7592 35.4411 22.9157 37.2111 22.9771C38.9965 23.0384 40.6746 21.8942 41.2912 20.2192C41.4875 19.6823 42.098 19.4952 42.5367 19.891C42.8619 20.1824 43.0981 20.5597 43.3527 20.9125C43.6135 21.2714 43.8742 21.6273 44.138 21.9862C44.3773 22.3145 44.1933 22.8176 43.8712 23.0078C43.4938 23.2286 43.0889 23.066 42.8527 22.7409C42.6073 22.4034 42.3618 22.066 42.1134 21.7285L41.6808 21.1364C41.644 21.0843 41.6041 21.0321 41.5673 20.98C41.7483 21.2285 41.5734 21.0291 41.4845 20.9463C41.8986 20.8358 42.3158 20.7254 42.73 20.618C41.8771 22.9433 39.7083 24.4987 37.2142 24.4711C34.7662 24.4435 32.6402 22.7623 31.8794 20.4708C32.2936 20.5812 32.7108 20.6916 33.1249 20.799C32.6126 21.3205 32.1003 21.842 31.588 22.3605C30.9131 23.0476 29.8578 21.9923 30.5327 21.3052Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.7633 23.2654C40.0486 23.8513 40.3339 24.4372 40.6192 25.0263C40.7971 25.3913 40.7204 25.83 40.3523 26.0447C40.021 26.238 39.5087 26.1429 39.3308 25.7778C39.0455 25.1919 38.7602 24.606 38.4749 24.017C38.2969 23.6519 38.3736 23.2132 38.7418 22.9985C39.0731 22.8052 39.5854 22.9003 39.7602 23.2654",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.8827 23.8021C35.6557 24.4126 35.4287 25.0261 35.2016 25.6366C35.0605 26.017 34.7016 26.2716 34.2844 26.1581C33.9193 26.0569 33.6218 25.6213 33.7629 25.2409C33.9899 24.6304 34.2169 24.0169 34.4439 23.4064C34.585 23.026 34.944 22.7714 35.3612 22.8849C35.7262 22.9861 36.0238 23.4217 35.8827 23.8021Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 18.9473,
			y: 30.3157,
			width: 10.1053,
			height: 1.26316,
			rx: .631579,
			fill: "#1C1C1C"
		})
	]
});
export default SvgMehFace;
